/** Mirrors finance PayrollStatus. */
export const PAYROLL_STATUSES = [
  { value: 'draft', label: 'Draft' },
  { value: 'finalized', label: 'Finalized' },
] as const;

export type PayrollStatus = (typeof PAYROLL_STATUSES)[number]['value'];

export const payrollStatusLabel = (s: string): string =>
  PAYROLL_STATUSES.find((x) => x.value === s)?.label ?? s;

export const payrollStatusVariant = (s: string): 'default' | 'outline' =>
  s === 'finalized' ? 'default' : 'outline';
